module.exports = __webpack_public_path__ + "images/share.jpg";


//////////////////
// WEBPACK FOOTER
// ./local_static/templates/guias/2018/assets/images/share.jpg
// module id = 339
// module chunks = 0